/**
 * @description Directory for ID Attributes on MID Health.
 * Naming Convention: "data-test-id-[VIEW/COMPONENT]-[ELEMENT]-[NAME]".
 * Example: id = "data-test-id-mainlayout-btn-cancel".
 */
const idDirectory = {
    divContainer: `midHealth-div-container`,
}

export default idDirectory
